import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { HsdpattasVerify } from "./sopDataTemplate";
import Select from "react-select";

interface AllProps {
  data: HsdpattasVerify;
  handleHsdpattaChange: any;
  isOnlyView?: boolean;
}
export class Hsdpatta extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (name, val) => {
    const { data } = this.props;
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleHsdpattaChange(data);
  };
  handleChildChange = (e, type) => {
    const { data } = this.props;
    if (e.target.name !== undefined) data[e.target.name] = e.target.value;
    else data[type][e.target.name] = e.target.value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleHsdpattaChange(data);
  };
  handleStateChange = (stateName, value) => {
    console.log("value", value);
    this.setState(
      {
        [stateName]: value,
      },
      () => {
        this.changeBgColor();
      },
    );
  };
  handleFileChange = (name, val) => {
    const { data } = this.props;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleHsdpattaChange(data);
  };

  getOtherProps = (key) => {
    // const { data, isOnlyView } = this.props;
    // if (isOnlyView) return { [key]: true };
    return null;
  };

  handleChildInputChange = (key, name, value, index?) => {
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleHsdpattaChange(data);
  };
  handleChildRadioChange = (key, name, val, index?) => {
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleHsdpattaChange(data);
  };

  addChild = (type) => {
    const { data } = this.props;
    data[type].push({
      roadApproachs: false,
      certificate: false,
      nocforTahsildar: false,
      conditionFullfilled: false,
      mentionCondition: "",
    });
    this.props.handleHsdpattaChange(data);
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    const updatedLegalHeirs = data[type].filter((item) => item !== null);
    data[type] = updatedLegalHeirs;
    this.props.handleHsdpattaChange(data);
  };

  // getAddButton = (title, value) => {
  //   return (
  //     <div style={{ display: "flex", justifyContent: "space-between" }}>
  //       <h6>
  //         <b></b>
  //       </h6>
  //       <div onClick={() => this.addChild(value)}>
  //         <button
  //           className="btn btn-sm btn-primary"
  //           style={{ fontSize: "smaller", marginBottom: "10%" }}
  //         >
  //           Add {title}
  //         </button>
  //       </div>
  //     </div>
  //   );
  // };
  getAddButton = (title, value, showRadioForSection) => {
    const { data } = this.props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h6 style={{ margin: 0 }}>
            <b>
              {title} {title === "HSD Patta" ? "" : ""}
            </b>
          </h6>

          {/* Show radio buttons only for the specified section */}
          {showRadioForSection === true && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <Form.Check
                inline
                label="Yes"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-yes`}
                checked={data[`isshow${value}Status`] === true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = true;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleHsdpattaChange(data);
                }}
                style={{ marginRight: "15px" }}
              />
              <Form.Check
                inline
                label="No"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-no`}
                checked={data[`isshow${value}Status`] !== true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = false;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleHsdpattaChange(data);
                }}
              />
            </div>
          )}
        </div>

        <div onClick={() => this.addChild(value)}>
          <button
            className="btn btn-sm btn-primary"
            style={{ fontSize: "smaller" }}
          >
            Add {title}
          </button>
        </div>
      </div>
    );
  };
  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };
  render() {
    const { data, isOnlyView } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data?.bgColor ? data?.bgColor : bgColor }}
              as={Card.Header}
              eventKey="8"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>HSD Patta</b>
              </h5>
              <i
                className={`icon feather icon-${!isOptionOpen ? "plus" : "minus"}`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                <div>
                  {/* {this.getAddButton("HSD Patta", "Hsdpattas")} */}
                  {this.getAddButton(
                    "HSD Patta",
                    "Hsdpattas",
                    true                    
                  )}
                  {data?.Hsdpattas &&
                    Array.isArray(data?.Hsdpattas) &&
                    data?.Hsdpattas.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10" key={index}>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Condition Fulfilled
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`conditionFullfilled-${index}`}
                                  type="radio"
                                  checked={value.conditionFullfilled === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "conditionFullfilled",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`conditionFullfilled-${index}`}
                                  type="radio"
                                  checked={value.conditionFullfilled === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "conditionFullfilled",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                NOC for Tahsildar
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`nocforTahsildar-${index}`}
                                  type="radio"
                                  checked={value.nocforTahsildar === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "nocforTahsildar",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`nocforTahsildar-${index}`}
                                  type="radio"
                                  checked={value.nocforTahsildar === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "nocforTahsildar",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                HSD Patta Issued by
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "hsdpattaissuedby" +
                                    (value && value.hsdpattaissuedby
                                      ? value.hsdpattaissuedby
                                      : "") +
                                    index
                                  }
                                  type="text"
                                  value={value.hsdpattaissuedby}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "Hsdpattas",
                                      "hsdpattaissuedby",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation("Hsdpattas", value, index) && (
                              <div
                                className="form-group col-md-2"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("Hsdpattas", index)
                                }
                              >
                                <i
                                  style={{ color: "red", float: "right" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mb-10">
                            <div className="col-md-4 mb-10">
                              <label className="label" style={{ padding: 0 }}>
                                Mention Condition(10/30 Years No Mortgage/Sale)
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "mentionCondition" +
                                  (value && value.mentionCondition
                                    ? value.mentionCondition
                                    : "") +
                                  index
                                }
                                type="text"
                                value={value.mentionCondition}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "Hsdpattas",
                                    "mentionCondition",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Boundary Certificate obtained
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "certificate" +
                                    (value && value.certificate
                                      ? value.certificate
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.certificate}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "certificate",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "certificate" +
                                    (value && !value.certificate
                                      ? !value.certificate
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.certificate}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "certificate",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Road Approach available
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "roadApproachs" +
                                    (value && value.roadApproachs
                                      ? value.roadApproachs
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.roadApproachs}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "roadApproachs",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "roadApproachs" +
                                    (value && !value.roadApproachs
                                      ? !value.roadApproachs
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.roadApproachs}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "Hsdpattas",
                                      "roadApproachs",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default Hsdpatta;
